<script>
import baseMixin from '@/mixins/baseMixin'
import navMixin from '@/mixins/navMixin'
import TheDashboardNavigationItem from './the-dashboard-navigation-item.vue'

export default {
  name: 'TheDashboardNavigation',
  components: { TheDashboardNavigationItem },
  mixins: [baseMixin, navMixin],
  computed: {
    filteredNavItems() {
      return this.navItems.filter((x) => x.key !== 'nav-home')
    },
  },
}
</script>

<template>
  <v-card class="transparent ma-0 pa-0" elevation="0">
    <v-card-text class="ma-0 pa-0">
      <v-row>
        <v-col
          v-for="item in filteredNavItems"
          :key="`${item.key}-dashboard`"
          cols="12"
          xs="6"
          sm="6"
          md="4"
          lg="4"
          xl="4"
        >
          <TheDashboardNavigationItem
            :payload="item"
            :is-active="isActiveNavItem(item.to)"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
